import { api } from '../core';
import { TOOLKIT_TAG } from '../constants';

export interface SaveUserToolkitToolRequest {
  globalAdminAsUser?: string;
  toolName: string;
  toolDescription: string;
  prompt: string;
}

const saveUserToolkitToolApi = api.injectEndpoints({
  endpoints: (builder) => ({
    saveUserToolkitTool: builder.mutation<void, SaveUserToolkitToolRequest>({
      query: (body) => ({
        url: 'toolkit/create-user-tool',
        method: 'POST',
        body,
      }),
      invalidatesTags: [TOOLKIT_TAG],
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

export const { useSaveUserToolkitToolMutation } = saveUserToolkitToolApi;
